import React, { useState, useEffect, useRef, useContext } from "react";
import { toast } from "react-toastify";
import { API } from "aws-amplify";
import TableGrid from "./TableGrid";
import CategoryList from "./CategoryList";
import MenuItems from "./MenuItems";
import OrderPanel from "./OrderPanel";
import PaymentModal from "./PaymentModal";
import ResponsivePOSLayout from "./Mobile-layout/mobile-pos";
import { useWebSocket } from "../../../../Context/WebSocketContext";
import PrintKOT from "./PrintKOT";
import PrintBill from "./PrintBill";
import { Context } from "../../../../Context";
import data from '../../../../../Operation/data.json';
const RestaurantPOS = ({ itemsData = [], institutionData, userData }) => {
  const { printerType } = data;
  const { setLoader } = useContext(Context);
  const { subscribe, isConnected } = useWebSocket();
  const [showReprintKOT, setShowReprintKOT] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [printAllItems, setPrintAllItems] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({});
  const [tableOccupancy, setTableOccupancy] = useState({});
  const [billItemsByStore, setBillItemsByStore] = useState({});
  const [ordersId,setorderId]=useState({});
  const totalTableNumber = institutionData?.Table?.length || 0;
  const [isAudioEnabled, setIsAudioEnabled] = useState(localStorage.getItem("audioEnabled") === "true");
   const [orderIds,setorderIds]=useState({})
  const [localBillItems, setLocalBillItems] = useState([]);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const pendingSoundRef = useRef(false);
  const [tables, setTables] = useState([
    ...Array(totalTableNumber).fill().map((_, i) => ({
      id: i + 1,
      name: `Table ${i + 1}`,
      status: "available",
      orders: [],
      currentBill: 0,
      orderType: "dineIn",
    })),
    { id: "takeaway1", name: "Takeaway 1", status: "available", orders: [], currentBill: 0, orderType: "takeaway" },
    { id: "takeaway2", name: "Takeaway 2", status: "available", orders: [], currentBill: 0, orderType: "takeaway" },
  ]);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [selectedTable, setSelectedTable] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [activeTab, setActiveTab] = useState("KOT");
  const [KOTByTable, setKOTByTable] = useState({});
  const [currentKOT, setCurrentKOT] = useState({ items: [], totalAmount: 0 });
  const [pendingOrders, setPendingOrders] = useState([]);
  const [pendingOrdersByTable, setPendingOrdersByTable] = useState({});
  const [tableData, setTableData] = useState({});
  const [showPrinterModal, setShowPrinterModal] = useState(false);
  const [allTablesData, setAllTablesData] = useState(null); // Add state to store all tables data
  const [tableInstructions, setTableInstructions] = useState({});
  // Bluetooth State
  const [device, setDevice] = useState(null);
  const [server, setServer] = useState(null);
  const [connected, setConnected] = useState(false);
  const [characteristics, setCharacteristics] = useState([]);

  // Bluetooth Functions
  const requestDevice = async () => {
    if (!navigator.bluetooth) {
      toast.error("Web Bluetooth API is not supported in this browser.");
      return;
    }
    try {
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: ["000018f0-0000-1000-8000-00805f9b34fb"],
      });
      setDevice(device);
      localStorage.setItem("bluetoothDeviceId", device.id);
      localStorage.setItem("bluetoothDeviceName", device.name);
      toast.success("Device selected: " + device.name);
      device.addEventListener("gattserverdisconnected", handleDisconnect);
      await connectToDevice(device);
    } catch (error) {
      console.error("Error requesting device:", error);
      toast.error("Failed to request Bluetooth device " );
    }
  };

  const handleDisconnect = () => {
    setConnected(false);
    setServer(null);
    setCharacteristics([]);
    toast.error("Printer disconnected. Please reconnect manually.");
  };

  const restoreConnection = async (deviceId, deviceName) => {
    if (!navigator.bluetooth) {
      toast.error("Web Bluetooth API is not supported in this browser.");
      return;
    }
    if (device && device.gatt.connected) {
      setServer(device.gatt);
      setConnected(true);
      await discoverServicesAndCharacteristics(device.gatt);
      toast.success("Restored connection to " + deviceName);
      return;
    }
    try {
      if (!device) {
        toast.info("Please reconnect to the printer manually.");
        return;
      }
      toast.info("Restoring connection to " + deviceName);
      await connectToDevice(device);
    } catch (error) {
      console.error("Error restoring connection:", error);
      toast.error("Failed to restore connection: " );
      setConnected(false);
    }
  };

  const connectToDevice = async (selectedDevice) => {
    if (!selectedDevice) {
      toast.error("No device selected.");
      return;
    }
    try {
      if (selectedDevice.gatt.connected) {
        setServer(selectedDevice.gatt);
        setConnected(true);
        await discoverServicesAndCharacteristics(selectedDevice.gatt);
        toast.success("Already connected to " + selectedDevice.name);
        return;
      }
      const server = await selectedDevice.gatt.connect();
      setServer(server);
      setConnected(true);
      toast.success("Connected to " + selectedDevice.name);
      await discoverServicesAndCharacteristics(server);
    } catch (error) {
      console.error("Error connecting to device:", error);
      toast.error("Failed to connect to device: ");
      setConnected(false);
    }
  };

  const discoverServicesAndCharacteristics = async (server) => {
    if (!server) return;
    try {
      const services = await server.getPrimaryServices();
      const chars = [];
      for (const service of services) {
        const characteristics = await service.getCharacteristics();
        chars.push(...characteristics);
      }
      setCharacteristics(chars);
      if (chars.length === 0) toast.error("No characteristics found.");
    } catch (error) {
      console.error("Error discovering services:", error);
      toast.error("Failed to discover services: " );
    }
  };

  const printData = async (data) => {
    if (!connected || !characteristics.length) {
      toast.error("No printer connected. Please connect first.");
      return;
    }
    try {
      const encoder = new TextEncoder();
      const encodedData = encoder.encode(data);
      const writeCharacteristic = characteristics.find(
        (char) => char.properties.write || char.properties.writeWithoutResponse
      );
      if (!writeCharacteristic) {
        toast.error("No writable characteristic found.");
        return;
      }
      const maxChunkSize = 512;
      for (let offset = 0; offset < encodedData.length; offset += maxChunkSize) {
        const chunk = encodedData.slice(offset, offset + maxChunkSize);
        await writeCharacteristic.writeValue(chunk);
      }
      toast.success("Print command sent successfully.");
    } catch (error) {
      console.error("Error sending data:", error);
      toast.error("Failed to print: ");
    }
  };

  // Show printer modal on every mount
  useEffect(() => {
    if (printerType === "local") {
      return;
    }
    setShowPrinterModal(true); // Always show modal on mount
    const storedDeviceId = localStorage.getItem("bluetoothDeviceId");
    const storedDeviceName = localStorage.getItem("bluetoothDeviceName");
    if (storedDeviceId && storedDeviceName && !device) {
      restoreConnection(storedDeviceId, storedDeviceName);
    }
  }, []); // Empty dependency array ensures it runs only on mount

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchAllTableData = async () => {
    try {
      setLoader(true);
      const result = await API.get("main", `/admin/get-tabledata/${institutionData.institution}`, {});
      
      // Parse the response
      const responseBody = result.body ? JSON.parse(result.body) : result;
      const responseData = responseBody.data || {};
      
      // Store the complete response data for future access
      setAllTablesData(responseData);
      
      // Transform the new object structure into an array format for compatibility
      let orderData = [];
      
      // If we got the new object format
      if (!Array.isArray(responseData)) {
        Object.entries(responseData).forEach(([tableId, tableInfo]) => {
          // For each table, extract its orders and merge with table info
          const tableOrders = tableInfo.orders || [];
          
          // If table has no orders but is still represented in the API response
          if (tableOrders.length === 0) {
            orderData.push({
              tableName: tableId,
              tableOccupied: tableInfo.tableOccupied,
              totalAmount: tableInfo.totalAmount || 0,
              totalCGST: tableInfo.totalCGST || 0,
              totalSGST: tableInfo.totalSGST || 0,
              totalServiceTax: tableInfo.totalServiceTax || 0,
              billItems: tableInfo.billItems || [],
              kotItems: tableInfo.kotItems || [],
              mergedItems: tableInfo.mergedItems || []
            });
          } else {
            // Add each order with table info
            tableOrders.forEach(order => {
              orderData.push({
                ...order,
                tableName: tableId,
                tableOccupied: tableInfo.tableOccupied
              });
            });
          }
        });
      } else { 
        // If somehow we still get the old array format
        orderData = responseData;
      }
       
      // Continue with existing code using the transformed orderData
      const allTableIds = [...new Set(orderData.map((order) => order.tableName))];
      const pendingOrders = orderData.filter((order) => !order.tableOccupied);
      const ordersByTable = pendingOrders.reduce((acc, order) => {
        acc[order.tableName] = acc[order.tableName] || [];
        acc[order.tableName].push(order);
        return acc;
      }, {});
      const occupancy = orderData.reduce((acc, order) => {
        acc[order.tableName] = order.tableOccupied === true;
        return acc;
      }, {});
      
      // Process all tables data
      const tableDataMap = {};
      
      if (!Array.isArray(responseData)) {
        // For each table in the response, populate our data structures
        Object.entries(responseData).forEach(([tableId, tableInfo]) => {
          processTableData(tableId, tableInfo);
          tableDataMap[tableId] = tableInfo;
        });
      }
      
      // Update tables
      setTables((prev) =>
        prev.map((table) => {
          const tableIdStr = String(table.id);
          if (!occupancy[tableIdStr] && !ordersByTable[tableIdStr]?.length) {
            return { ...table, orders: [], currentBill: 0, status: "available" };
          }
          const tableInfo = responseData[tableIdStr];
          if (tableInfo && tableInfo.mergedItems && tableInfo.mergedItems.length > 0) {
            return { 
              ...table, 
              orders: tableInfo.mergedItems, 
              currentBill: tableInfo.totalAmount || 0, 
              status: "occupied" 
            };
          }
          return table;
        })
      );
      console.log("Pendings Orders",tableDataMap);
      setPendingOrders(pendingOrders);
      setPendingOrdersByTable(ordersByTable);
      setTableOccupancy(occupancy);
      setTableData(tableDataMap);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching table data:", error);
      setLoader(false);
    }
  };
  const processTableData = (tableId, tableInfo) => {
    if (!tableId || !tableInfo) return;
    
    const tableIdStr = String(tableId);
      const orderId = tableInfo.orders && tableInfo.orders.length > 0 
  ? tableInfo.orders
      .map(order => order.orderId)          
      .filter(id => id !== null && id !== undefined) 
      .join(',')                          
  : null;

setorderId((prev) => ({ 
  ...prev, 
  [tableIdStr]: orderId  
}));
    
    const kotItems = tableInfo.kotItems || [];
    const billItems = tableInfo.billItems || [];
    const mergedItems = tableInfo.mergedItems || [];
    const totalAmount = tableInfo.totalAmount || 0;
    const totalCGST = tableInfo.totalCGST || "0.00";
    const totalSGST = tableInfo.totalSGST || "0.00";
    const totalServiceTax = tableInfo.totalServiceTax || "0.00";
    const phoneNumber = tableInfo.phoneNumber || "";
    const customerName = tableInfo.customerName || "";
    const kotNumber = tableInfo.kotNumber || "";
    const instruction = tableInfo.instruction || "";
    // Update states
    setCustomerDetails((prev) => ({ 
      ...prev, 
      [tableIdStr]: { phone: phoneNumber, name: customerName } 
    }));
    
    setBillItemsByStore((prev) => ({
      ...prev,
      [tableIdStr]: {
        items: kotItems.map((item) => ({ ...item, name: item.name })),
        billItems: billItems.map((item) => ({ ...item, name: item.name })),
        totalAmount,
      },
    }));
    
    setTableData((prev) => ({
      ...prev,
      [tableIdStr]: { kotItems, billItems, mergedItems, totalAmount, totalCGST, totalSGST, totalServiceTax,instruction },
    }));
    
    setKOTByTable((prev) => ({
      ...prev,
      [tableIdStr]: {
        items: kotItems.map((item) => ({ ...item, name: item.name })),
        billItems: billItems.map((item) => ({ ...item, name: item.name })),
        totalAmount,
        kotNumber,
      },
    }));
    setTableInstructions((prev) => ({
    ...prev,
    [tableIdStr]: instruction
  }));
    if (String(selectedTable?.id) === tableIdStr) {
      setCurrentKOT({ 
        items: kotItems.map((item) => ({ ...item, name: item.name })), 
        totalAmount 
      });
    }
  };
  
  // Enhanced function that pulls from allTablesData instead of making an API call
  const fetchTableData = async (tableId) => {
    if (!tableId || !institutionData?.institution) return null;
    setLoader(true);
    const tableIdStr = String(tableId);
    
    try {
      // Check if we already have all tables data cached
      if (allTablesData && allTablesData[tableIdStr]) {
        // Use cached data instead of making a new API call
        const tableInfo = allTablesData[tableIdStr];
        processTableData(tableIdStr, tableInfo);
        setLoader(false);
        return tableInfo;
      } else {
        // // If not cached or specific table not in cache, fall back to API call
        // // const response = await API.get("main", `/admin/tables/${institutionData.institution}/${tableIdStr}`);
        // let parsedData = response.body ? JSON.parse(response.body) : response;
        
        // // Handle response format
        // const tableData = parsedData.data && parsedData.data[tableIdStr] 
        //   ? parsedData.data[tableIdStr] 
        //   : parsedData;
        
        // // Process the data using our helper function
        // processTableData(tableIdStr, tableData);
        
        setLoader(false);
        // return tableData;
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
      setLoader(false);
      return null;
    }
  };
  
  const addItemToKOT = (tableId, item) => {
    if (!tableId) return;
    const tableIdStr = String(tableId);
    setTableData((prev) => {
      const currentTable = prev[tableIdStr] || { kotItems: [], billItems: [], mergedItems: [], totalAmount: 0, totalCGST: "0.00", totalSGST: "0.00", totalServiceTax: "0.00" };
      const existingItem = currentTable.mergedItems.find((i) => i.itemId === item.itemId);
      const updatedMergedItems = existingItem
        ? currentTable.mergedItems.map((i) => (i.itemId === item.itemId ? { ...i, quantity: i.quantity + 1 } : i))
        : [...currentTable.mergedItems, { ...item, quantity: 1 }];
      const updatedKotItems = updatedMergedItems.filter((item) => currentTable.billItems.every((billItem) => billItem.itemId !== item.itemId));
      const totalAmount = updatedMergedItems.reduce((sum, i) => sum + i.price * i.quantity, 0);
      const cgst = totalAmount * 0.09;
      const sgst = totalAmount * 0.09;
      const serviceTax = totalAmount * 0.05;
      return {
        ...prev,
        [tableIdStr]: { ...currentTable, kotItems: updatedKotItems, mergedItems: updatedMergedItems, totalAmount, totalCGST: cgst.toFixed(2), totalSGST: sgst.toFixed(2), totalServiceTax: serviceTax.toFixed(2) },
      };
    });
    setKOTByTable((prev) => {
      const currentKOT = prev[tableIdStr] || { items: [], totalAmount: 0 };
      const newItems = currentKOT.items.some((i) => i.itemId === item.itemId)
        ? currentKOT.items.map((i) => (i.itemId === item.itemId ? { ...i, quantity: i.quantity + 1 } : i))
        : [...currentKOT.items, { ...item, quantity: 1 }];
      const updatedKOT = { items: newItems, totalAmount: newItems.reduce((sum, i) => sum + i.price * i.quantity, 0) };
      setCurrentKOT(updatedKOT);
      return { ...prev, [tableIdStr]: updatedKOT };
    });
  };

  const updateItemQuantity = (tableId, itemId, newQuantity) => {
    if (newQuantity < 1) return removeItemFromKOT(tableId, itemId);
    const tableIdStr = String(tableId);
    setTableData((prev) => {
      const currentTable = prev[tableIdStr] || { kotItems: [], billItems: [], mergedItems: [], totalAmount: 0, totalCGST: "0.00", totalSGST: "0.00", totalServiceTax: "0.00" };
      const updatedMergedItems = currentTable.mergedItems.map((i) => (i.itemId === itemId ? { ...i, quantity: newQuantity } : i));
      const updatedKotItems = updatedMergedItems.filter((item) => currentTable.billItems.every((billItem) => billItem.itemId !== item.itemId));
      const totalAmount = updatedMergedItems.reduce((sum, i) => sum + i.price * i.quantity, 0);
      const cgst = totalAmount * 0.09;
      const sgst = totalAmount * 0.09;
      const serviceTax = totalAmount * 0.05;
      return {
        ...prev,
        [tableIdStr]: { ...currentTable, kotItems: updatedKotItems, mergedItems: updatedMergedItems, totalAmount, totalCGST: cgst.toFixed(2), totalSGST: sgst.toFixed(2), totalServiceTax: serviceTax.toFixed(2) },
      };
    });
    setKOTByTable((prev) => {
      const currentKOT = prev[tableIdStr] || { items: [], totalAmount: 0 };
      const newItems = currentKOT.items.map((i) => (i.itemId === itemId ? { ...i, quantity: newQuantity } : i));
      const updatedKOT = { items: newItems, totalAmount: newItems.reduce((sum, i) => sum + i.price * i.quantity, 0) };
      setCurrentKOT(updatedKOT);
      return { ...prev, [tableIdStr]: updatedKOT };
    });
  };

  const removeItemFromKOT = (tableId, itemId) => {
    const tableIdStr = String(tableId);
    setTableData((prev) => {
      const currentTable = prev[tableIdStr] || { kotItems: [], billItems: [], mergedItems: [], totalAmount: 0, totalCGST: "0.00", totalSGST: "0.00", totalServiceTax: "0.00" };
      const updatedMergedItems = currentTable.mergedItems.filter((i) => i.itemId !== itemId);
      const updatedKotItems = updatedMergedItems.filter((item) => currentTable.billItems.every((billItem) => billItem.itemId !== item.itemId));
      const totalAmount = updatedMergedItems.reduce((sum, i) => sum + i.price * i.quantity, 0);
      const cgst = totalAmount * 0.09;
      const sgst = totalAmount * 0.09;
      const serviceTax = totalAmount * 0.05;
      return {
        ...prev,
        [tableIdStr]: { ...currentTable, kotItems: updatedKotItems, mergedItems: updatedMergedItems, totalAmount, totalCGST: cgst.toFixed(2), totalSGST: sgst.toFixed(2), totalServiceTax: serviceTax.toFixed(2) },
      };
    });
    setKOTByTable((prev) => {
      const currentKOT = prev[tableIdStr] || { items: [], totalAmount: 0 };
      const newItems = currentKOT.items.filter((i) => i.itemId !== itemId);
      const updatedKOT = { items: newItems, totalAmount: newItems.reduce((sum, i) => sum + i.price * i.quantity, 0) };
      setCurrentKOT(updatedKOT);
      return { ...prev, [tableIdStr]: updatedKOT };
    });
  };

  const saveKOT = async (selectedTable) => {
    setLoader(true);
    const tableIdStr = String(selectedTable.id);
    const tableDataForTable = tableData[tableIdStr] || { kotItems: [], billItems: [], mergedItems: [], totalAmount: 0, totalCGST: "0.00", totalSGST: "0.00", totalServiceTax: "0.00" };
    if (tableDataForTable.mergedItems.length === 0) {
      setLoader(false);
      return;
    }
    try {
      const result = await API.get("main", `/admin/get-tabledata/${institutionData.institution}`, {});
      const responseBody = result.body ? JSON.parse(result.body) : result;
      const responseData = responseBody.data || {};
      
      // Store the complete response for future use
      setAllTablesData(responseData);
      
      // Check if this table has an existing order
      const hasExistingOrder = !Array.isArray(responseData) 
        ? (responseData[tableIdStr] && responseData[tableIdStr].orders && responseData[tableIdStr].orders.length > 0)
        : responseData.some(order => order.tableName === tableIdStr);
      
      if (!hasExistingOrder) {
        await API.post("main", `/any/create-order/${institutionData.institution}`, {
          body: {
            name: customerDetails[tableIdStr]?.name || "",
            phoneNumber: customerDetails[tableIdStr]?.phone || "",
            tableName: tableIdStr,
            totalAmount: tableDataForTable.totalAmount,
            currency: tableDataForTable.mergedItems[0]?.currency || "INR",
            items: tableDataForTable.mergedItems,
            cgst: tableDataForTable.totalCGST,
            sgst: tableDataForTable.totalSGST,
            serviceTax: tableDataForTable.totalServiceTax,
            ...(userData && { orderBy: userData.cognitoId }),
            tableOccupied:true
          },
        });
        // await API.post("main", `/admin/accept-order/${institutionData.institution}`, { body: { tableName: tableIdStr, institution: institutionData.institution } });
        await API.post("main", `/admin/orders-kot/${institutionData.institution}/${tableIdStr}`, { body: { items: tableDataForTable.mergedItems } });
        toast.success("KOT Saved Successfully");
      } else {
        await API.put("main", `/admin/orders-items/${institutionData.institution}/${tableIdStr}`, {
          body: { items: tableDataForTable.mergedItems, serviceTaxPercentage: institutionData?.serviceTax !== undefined ? institutionData.serviceTax: 0,
            cgstPercentage: institutionData?.cgst !== undefined ? institutionData.cgst : 2.5,
            sgstPercentage: institutionData?.sgst !== undefined ? institutionData.sgst : 2.5 },
        });
        await API.post("main", `/admin/orders-bill/${institutionData.institution}/${tableIdStr}`, {
          body: { name: customerDetails[tableIdStr]?.name || "", phoneNumber: customerDetails[tableIdStr]?.phone || "", items: tableDataForTable.mergedItems },
        });
        toast.success("KOT Updated Successfully");
      }
      setLoader(false);
      
      // After updating the KOT, refresh all tables data
      fetchAllTableData();
    } catch (error) {
      console.error("Error saving KOT:", error);
      setLoader(false);
      toast.error("Failed to save KOT.");
    }
  };

  const settleBill = async () => {
    if (!selectedTable || !localBillItems.length) return;
    setLoader(true);
    const tableIdStr = String(selectedTable.id);
    try {
      await API.put("main", `/admin/orders-items/${institutionData.institution}/${tableIdStr}`, {
        body: { items: localBillItems, serviceTaxPercentage: institutionData?.serviceTax !== undefined ? institutionData.serviceTax: 0,
          cgstPercentage: institutionData?.cgst !== undefined ? institutionData.cgst : 2.5,
          sgstPercentage: institutionData?.sgst !== undefined ? institutionData.sgst : 2.5},
      });
      await API.post("main", `/admin/orders-bill/${institutionData.institution}/${tableIdStr}`, { body: { items: localBillItems } });
      setTables((prev) => prev.map((t) => (String(t.id) === tableIdStr ? { ...t, orders: [], currentBill: 0, status: "available" } : t)));
      setTableOccupancy((prev) => ({ ...prev, [tableIdStr]: false }));
      setLocalBillItems([]);
      setKOTByTable((prev) => ({ ...prev, [tableIdStr]: { items: [], totalAmount: 0 } }));
      setCurrentKOT({ items: [], totalAmount: 0 });
      
      // After settling bill, refresh all tables data
      await fetchAllTableData();
      
      setLoader(false);
      toast.success("Bill settled successfully!");
    } catch (error) {
      console.error("Error settling bill:", error);
      setLoader(false);
      toast.error("Failed to settle bill.");
    }
  };

  // Additional function to get specific table data from already fetched data
  const getTableDataFromCache = (tableId) => {
    if (!tableId || !allTablesData) return null;
    const tableIdStr = String(tableId);
    
    // If we have this table in our cached data
    if (allTablesData[tableIdStr]) {
      // Instead of fetching, use the cached data and process it
      processTableData(tableIdStr, allTablesData[tableIdStr]);
      return allTablesData[tableIdStr];
    }
    
    // If not found in cache, return null (should trigger a fetch)
    return null;
  };

  // Load selected table data from cache when table is selected
  useEffect(() => {
    if (selectedTable) {
      const tableIdStr = String(selectedTable.id);
      const currentLocalData = tableData[tableIdStr];
      
      if (!currentLocalData) {
        const cachedData = getTableDataFromCache(tableIdStr);
        if (!cachedData) {
          fetchTableData(tableIdStr);
        }
      }
    }
  }, [selectedTable]);

  useEffect(() => {
    fetchAllTableData();
  }, [institutionData.institution]);

  const notificationSound = new Audio("/notification-18-270129.mp3");
  const enableAudio = () => {
    notificationSound.play().then(() => {
      notificationSound.pause();
      notificationSound.currentTime = 0;
      setIsAudioEnabled(true);
      setHasUserInteracted(true);
      localStorage.setItem("audioEnabled", "true");
      toast.success("Notifications enabled!");
      if (pendingSoundRef.current) {
        notificationSound.play().catch(console.error);
        pendingSoundRef.current = false;
      }
    }).catch((error) => {
      console.error("Error enabling audio:", error);
      toast.error("Failed to enable notifications");
    });
  };

  useEffect(() => {
    const handleInteraction = () => {
      setHasUserInteracted(true);
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
      if (pendingSoundRef.current && isAudioEnabled) {
        notificationSound.play().catch(console.error);
        pendingSoundRef.current = false;
      }
    };
    window.addEventListener("click", handleInteraction);
    window.addEventListener("keydown", handleInteraction);
    return () => {
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
    };
  }, [isAudioEnabled]);

  useEffect(() => {
    const unsubscribe = subscribe((message) => {
      if (message) {
        toast.info("New order received!");
        fetchAllTableData();
        if (isAudioEnabled && hasUserInteracted) {
          notificationSound.play().catch((error) => console.error("Failed to play notification sound:", error));
        } else {
          pendingSoundRef.current = true;
        }
      }
    });
    return () => unsubscribe();
  }, [institutionData.institution, subscribe, isConnected, isAudioEnabled, hasUserInteracted]);
  // Printer Selection Modal
  const PrinterModal = () => (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg relative">
        <button
          onClick={() => setShowPrinterModal(false)}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <svg 
            className="w-6 h-6" 
            fill="none" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        <h2 className="text-lg font-semibold mb-4">Select Printing Method</h2>
        <p className="mb-4">How would you like to handle printing?</p>
        <div className="flex gap-4">
          <button
            onClick={() => {
              requestDevice();
              setShowPrinterModal(false);
            }}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Bluetooth Printer
          </button>
          <button
            onClick={() => {
              setShowPrinterModal(false);
              toast.info("Local printing selected.");
            }}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            Wired Printer
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {!isAudioEnabled && (
        <div className="fixed top-6 right-6 z-50 animate-fade-in">
          <button
            onClick={enableAudio}
            className="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-white transition-all duration-300 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            <span className="absolute inset-0 w-full h-full transition-all duration-300 ease-out bg-indigo-500 opacity-0 group-hover:opacity-20"></span>
            <span className="relative flex items-center gap-2">
              <svg className="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
              </svg>
              Enable Notifications
            </span>
          </button>
        </div>
      )}
      {screenWidth > 700 ? (
        <div className="flex h-screen bg-gray-50">
          <div className="flex-1 flex flex-col">
            <TableGrid tables={tables} selectedTable={selectedTable} setSelectedTable={setSelectedTable} pendingOrdersByTable={pendingOrdersByTable} KOTByTable={KOTByTable} />
            <div className="flex flex-1">
              <CategoryList categories={["All", ...new Set(itemsData.map((item) => item.category))]} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />
              <MenuItems
                itemsData={itemsData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                selectedCategory={selectedCategory}
                selectedTable={selectedTable}
                addItemToKOT={addItemToKOT}
                categories={["All", ...new Set(itemsData.map((item) => item.category))]}
                setSelectedCategory={setSelectedCategory}
              />
            </div>
          </div>
          <OrderPanel
            selectedTable={selectedTable}
            billItemsByStore={billItemsByStore}
            tables={tables}
            setSelectedTable={setSelectedTable}
            setCurrentKOT={setCurrentKOT}
            fetchPendingOrders={fetchAllTableData}
            activeTab={activeTab}
            setTables={setTables}
            setActiveTab={setActiveTab}
            KOTByTable={KOTByTable}
            customerDetails={customerDetails}
            updateItemQuantity={updateItemQuantity}
            setCustomerDetails={setCustomerDetails}
            removeItemFromKOT={removeItemFromKOT}
            setLocalBillItems={setLocalBillItems}
            localBillItems={localBillItems}
            printKOT={(table) => PrintKOT({ table, customerDetails, KOTByTable, institutionData, saveKOT, screenWidth, setActiveTab, tableData, printData, connected,tableInstructions })}
            setTableOccupancy={setTableOccupancy}
            printBill={({ table, items, orderId }) => PrintBill({ table, items, institutionData, screenWidth, orderId })}
            setShowModal={setShowModal}
            printAllItems={printAllItems}
            setPrintAllItems={setPrintAllItems}
            setKOTByTable={setKOTByTable}
            tableOccupancy={tableOccupancy}
            pendingOrders={selectedTable ? pendingOrdersByTable[String(selectedTable.id)] || [] : []}
            fetchTableData={fetchTableData}
            tableData={tableData}
            saveKOT={saveKOT}
            settleBill={settleBill}
            bluetoothConnected={connected}
            bluetoothDeviceName={device?.name}
            connectBluetooth={requestDevice}
            printBluetooth={printData}
            setShowReprintKOT={setShowReprintKOT}
            showReprintKOT={showReprintKOT}
          />
          {showModal && (
            <PaymentModal
              saveKOT={() => saveKOT(selectedTable)}
              selectedTable={selectedTable}
              institutionData={institutionData}
              localBillItems={localBillItems}
              onClose={() => setShowModal(false)}
              setKOTByTable={setKOTByTable}
              setTables={setTables}
              setCurrentKOT={setCurrentKOT}
              setCustomerDetails={setCustomerDetails}
              fetchPendingOrders={fetchAllTableData}
              setTableOccupancy={setTableOccupancy}
            orderId={ordersId[String(selectedTable?.id)]}
              customerDetails={customerDetails}
            />
          )}
        </div>
      ) : (
        <div className="flex h-screen bg-gray-50">
          <ResponsivePOSLayout
            categories={["All", ...new Set(itemsData.map((item) => item.category))]}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            tables={tables}
            selectedTable={selectedTable}
            setSelectedTable={setSelectedTable}
            itemsData={itemsData}
            setTables={setTables}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            addItemToKOT={addItemToKOT}
            billItemsByStore={billItemsByStore}
            localBillItems={localBillItems}
            setLocalBillItems={setLocalBillItems}
            setTableOccupancy={setTableOccupancy}
            KOTByTable={KOTByTable}
            removeItemFromKOT={removeItemFromKOT}
            updateItemQuantity={updateItemQuantity}
            printKOT={(table) => PrintKOT({ table, customerDetails, KOTByTable, institutionData, saveKOT, screenWidth, setActiveTab, tableData, printData, connected,tableInstructions })}
            printBill={({ table, items, orderId }) => PrintBill({ table, items, institutionData, screenWidth, orderId })}
            customerDetails={customerDetails}
            setCustomerDetails={setCustomerDetails}
            setShowModal={setShowModal}
            printAllItems={printAllItems}
            setPrintAllItems={setPrintAllItems}
            institutionData={institutionData}
            pendingOrdersByTable={pendingOrdersByTable}
            fetchPendingOrders={fetchAllTableData}
            pendingOrders={selectedTable ? pendingOrdersByTable[String(selectedTable.id)] || [] : []}
            tableOccupancy={tableOccupancy}
            setCurrentKOT={setCurrentKOT}
            setKOTByTable={setKOTByTable}
            fetchTableData={fetchTableData}
            tableData={tableData}
            saveKOT={saveKOT}
            settleBill={settleBill}
            bluetoothConnected={connected}
            bluetoothDeviceName={device?.name}
            connectBluetooth={requestDevice}
            printBluetooth={printData}
            setShowReprintKOT={setShowReprintKOT}
            showReprintKOT={showReprintKOT}
          />
          {showModal && (
            <PaymentModal
              saveKOT={() => saveKOT(selectedTable)}
              selectedTable={selectedTable}
              institutionData={institutionData}
              localBillItems={localBillItems}
              onClose={() => setShowModal(false)}
              setKOTByTable={setKOTByTable}
              setTables={setTables}
              setCurrentKOT={setCurrentKOT}
              setCustomerDetails={setCustomerDetails}
              fetchPendingOrders={fetchAllTableData}
              setTableOccupancy={setTableOccupancy}
              orderId={ordersId[String(selectedTable?.id)]}
              customerDetails={customerDetails}
            />
          )}
        </div>
      )}
      {showPrinterModal && <PrinterModal />}
    </>
  );
};

export default RestaurantPOS;